/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestVkontaktePlayOptions, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestVkontaktePlayOptionsFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestVkontaktePlayOptionsToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestVkontaktePlayOptions';
export function FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayFromJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestVkontaktePlayOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestVkontaktePlayOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayToJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestVkontaktePlayOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestVkontaktePlayOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlay.js.map